import { createReducer } from '@reduxjs/toolkit';

import getCompatibilityCarsGroup from '../../thunks/Compatibility/getCompatibilityCarsGroup';

const initialState = {
  loading: false,
  error: '',
  carsGroup: undefined,
};

const getCompatibilityCarsGroupReducer = createReducer(initialState, {
  [getCompatibilityCarsGroup.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCompatibilityCarsGroup.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    loading: false,
    carsGroup: data,
  }),
  [getCompatibilityCarsGroup.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCompatibilityCarsGroupReducer;
